import React from "react";
import Fade from "@material-ui/core/Fade";
import { CircularProgress } from "../../common_components/Progress";
import useStyles from "./useStyles";

export default function LoadingPage({ children }) {
    const classes = useStyles();
    const timerRef = React.useRef();

    React.useEffect(
        () => () => {
            clearTimeout(timerRef.current);
        },
        []
    );

    return (
        <div className={classes.root}>
            <Fade
                in={true}
                style={{
                    transitionDelay: "100ms",
                }}
                unmountOnExit
            >
                <CircularProgress />
            </Fade>
            <div>{children}</div>
        </div>
    );
}
